import React from 'react'

import clsx from 'clsx'

import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'

import classes from './KeyFeaturesHeading.module.scss'

/** @type {import("./types").default} */
const KeyFeaturesHeading = ({ label, listing, className, ...props }) => {
  const { num_reviews } = listing

  const { category } = useAppContext()
  return (
    <div className={clsx('KeyFeaturesHeading', classes.root, className)} {...props}>
      <Typography variant="heading-xs" component="span">
        Key Features
      </Typography>
      <InfoCircleTooltip
        className={classes.infoCircle}
        title={`Key features of ${category.name} software based on ${num_reviews} verified user reviews.`}
        enterTouchDelay={100}
        leaveTouchDelay={3000}
      />
      <Tag size="small" color="grey" className={classes.tag}>
        {label}
      </Tag>
    </div>
  )
}
export default KeyFeaturesHeading
